import { useEffect, useMemo, useState } from 'react';
import { AssignmentCategory } from '../../../../constants/types/lms/student/homework/type';
import { myLearingInfoDetailType } from '../../../../constants/types/student-type';

export const useAssignmentCategory = (classDetail: myLearingInfoDetailType) => {
  const classType: AssignmentCategory = useMemo(() => {
    if (!classDetail) return 'NONE';

    let divisionStr: AssignmentCategory = 'NONE';

    switch (classDetail.course.id) {
      case 'Irmk2AAW2RWV-iHn': // 영어교실 베이직
        divisionStr = 'JEBSON';
        break;
      case 'VY6Yl4kxQsb3sYJZ': // WMW
        divisionStr = 'WMW';
        break;
      case 'GXHrE6RAfYafHfgs': // HFHJ
        divisionStr = 'HFHJ';
        break;
      default:
        divisionStr = 'NONE';
        break;
    }

    return divisionStr;
  }, [classDetail]);

  const [selectedCategory, setSelectedCategory] =
    useState<AssignmentCategory>('NONE');

  useEffect(() => {
    setSelectedCategory(classType);
  }, [classType]);

  const onCategoryChange = (category: AssignmentCategory) => {
    setSelectedCategory(category);
  };

  return {
    classType,
    selectedCategory,
    onCategoryChange,
  };
};
